import { pickBy } from 'lodash';
export const getArticles = (state, assetId) => {
    return pickBy(state.articles.resources, (article) => article.asset === assetId);
};
